<template>
    <div>
        <span>{{ getActorName }} kullanıcısı "{{ $_.get(activity, 'payload.taskTitle') }}" adlı görevin sahibini "{{ $_.get(activity, 'payload.oldOwner') }}" den "{{ $_.get(activity, 'payload.newOwner') }}" olarak değiştirdi<span v-if="ruleSource"> (<em>{{ ruleSource }}</em> aracılığıyla)</span>.</span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskUpdateOwner",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        getActorName() {
            const actorName = this.$_.get(this.activity, "actorUser.name");
            if (actorName) return actorName;
            if (this.$_.get(this.activity, "actor") === "system") return "Sistem";
            return "Bilinmeyen";
        },
        ruleSource() {
            return this.$_.get(this.activity, "payload.ruleSource");
        }
    }
});
</script>
<style scoped lang="scss"></style>
